import { format, isValid, parseISO } from 'date-fns'
import { isEmpty } from 'lodash'

export default function formatUTCAsLocalDateTime(dateString) {
  // Convert that UTC value of dateString to the viewer’s local date and time
  if (isEmpty(dateString)) return

  const date = parseISO(dateString)
  // Some API fields arrive already formatted (e.g. "10/09/26"), which
  // parseISO cannot read. Show those as-is rather than throwing.
  if (!isValid(date)) return dateString

  return format(date, 'P p') // e.g. Feb 19, 2026 at 10:00 AM
}
